import { BitmapText, Container } from '@pixi/react'
import { memo, useMemo } from 'react'
import { useGodziDropStore } from '../../domain/godzi/store/godziDropStore'
import { GodziSpinType, SpinePlayer } from '@slot-nx/core'

export const GodziSpinButton = memo(() => {
  const [godziSpinType, freeSpinCount] = useGodziDropStore(state => [state.godziSpinType, state.freeSpinCount, state.isIconOpen])
  const godziRoundContent = useMemo(() => {
    return (
      <BitmapText
        key="roundText"
        name="roundText"
        text={freeSpinCount.toString()}
        x={0}
        y={75}
        style={{ fontName: 'GodziFont', fontSize: 20, align: 'center' }}
        anchor={[0.5, 2]}
        visible={godziSpinType === GodziSpinType.freeSpin}
      />
    )
  }, [freeSpinCount, godziSpinType])

  if (godziSpinType === GodziSpinType.none) return null

  return (
    <Container
      name="GodziSpinButton"
      x={540}
      y={1690}
      scale={1}
    >

      <SpinePlayer
        x={0}
        y={75}
        data="FSbtn.skel"
        atlas="FSbtn.atlas"
        loop={true}
        animationStr={godziSpinType}
        scale={1}
      />

      {godziRoundContent}

    </Container>
  )
})
